define('modules/accounts/users/detail/view',['require','exports','module','lodash','jquery','views/BaseView','views/AlertView','base/model','./form-user-view','./form-user-services-view','./../modal/view','./listLoginHistory','./modalLoginHistory/view','../../../../helpers/PasswordValidatorHelper','helpers/CommonHelper','./../../../private/view-mdsidebar','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var _ = require("lodash");
  var $ = require("jquery");
  var BaseView = require("views/BaseView");
  var AlertView = require("views/AlertView");
  var BaseModel = require("base/model");
  var FormUserView = require("./form-user-view");
  var FormUserServicesView = require("./form-user-services-view");
  var ModalCompanyView = require("./../modal/view");
  var ListLoginHistoryModel = require("./listLoginHistory");
  var ModalLoginHistoryView = require("./modalLoginHistory/view");
  var PasswordValidatorHelper = require("../../../../helpers/PasswordValidatorHelper");
  var CommonHelper = require("helpers/CommonHelper");
  var MDSidebarJS = require("./../../../private/view-mdsidebar");
  var scrollTop = function () {
    $("html,body").scrollTop(0);
  };

  var View = BaseView.extend({
    template: require("ldsh!./template"),
    alertView: null,
    listLoginHistoryModel: null,

    events: {
      "click #cancelFormUser": "goBack",
      "click #expandAccountServices": "expandAccountServices",
      "click .activateUserservice": "activateUserservice",
      "click .modalLoginHistoryLink": "renderModalLoginHistory",
    },
    initialize: function () {
      var self = this;
      this.alertView = null;

      if (this.model) {
        this.listenTo(this.model, "reset sync request error", function () {
          self.render();
          if (self.alertView) {
            $("#messages-container").append(self.alertView.render().el);
          }
        });
      }
    },

    sha256: function (data, callback) {
      var textAsBuffer = new TextEncoder().encode(data);
      window.crypto.subtle
        .digest("SHA-256", textAsBuffer)
        .then(function (hashBuffer) {
          var hashArray = Array.from(new Uint8Array(hashBuffer));
          var digest = hashArray
            .map(function (b) {
              return b.toString(16).padStart(2, "0");
            })
            .join("");
          callback(digest);
        });
    },
    expandAccountServices: function (event) {
      scrollTop();
      var serviceId = $(event.currentTarget).attr("data-serviceId");
      var MyApp = new Backbone.Router();
      if (serviceId == 2) {
        MyApp.navigate("payments/landings", { trigger: true });
      }
      if (serviceId == 1) {
        MyApp.navigate("payments/mdirector", { trigger: true });
      }
    },
    getDataForService: function (serviceId) {
      var services = this.group.get("services"),
        dataLimitsService;
      _.each(services, function (service) {
        if (service.id == serviceId) {
          dataLimitsService = service;
        }
      });
      return dataLimitsService;
    },
    getDataUserForService: function (serviceId) {
      var services = this.model.get("services"),
        dataUserService;
      _.each(services, function (service) {
        if (service.id == serviceId) {
          dataUserService = service;
        }
      });
      return dataUserService;
    },

    renderModalServices: function (serviceId, dataLimitsService) {
      var modalview = new ModalCompanyView({
        me: this.me,
        serviceId: serviceId,
        dataLimitsService: dataLimitsService,
      });
      $("#renderModalServices").html(modalview.render().el);
    },
    activateUserservice: function (event) {
      var serviceId = $(event.currentTarget).attr("data-serviceId");
      var dataLimitsService = this.getDataForService(serviceId);
      var dataUserService = this.getDataUserForService(serviceId);

      if (this.model.isNew()) {
        if (dataLimitsService.numUsers >= dataLimitsService.maxUsers) {
          this.renderModalServices(serviceId, dataLimitsService);
          event.preventDefault();
          $(event).prop("checked", false);
          $("#modalLimitService").modal("show");
        }
      } else {
        if (
          !dataUserService.activeServiceUser &&
          dataLimitsService.numUsers >= dataLimitsService.maxUsers
        ) {
          this.renderModalServices(serviceId, dataLimitsService);
          event.preventDefault();
          $(event).prop("checked", false);
          $("#modalLimitService").modal("show");
        }
      }
    },

    goBack: function () {
      var MyApp = new Backbone.Router();
      MyApp.navigate("accounts/users", { trigger: true });
    },

    beforeRender: function () {
      var self = this;
      this.insertView(
        "#form-user",
        new FormUserView({
          model: this.model,
          profile: this.myself,
          groupId: this.options.group.id,
          isSuperAdmim: this.me.isSuperAdmim(),
        })
      );
      _.each(this.model.get("services"), function (service) {
        self.insertView(
          "#form-user-services",
          new FormUserServicesView({
            model: new BaseModel(service),
            isnew: self.model.isNew(),
            group: self.options.group.get("services")[service.id],
          })
        );
      });
    },

    cleanSensibleFormFields: function () {
      var sensibleFields = ["current-password", "password", "repeat-password"];

      $.each(sensibleFields, function (i, field) {
        $("#" + field).val("");
      });
    },
    afterRender: function () {
      BaseView.prototype.afterRender.call(this);
      this.cleanSensibleFormFields();

      var self = this,
        dataUser = this.serialize().user.attributes,
        $role = $("#role"),
        $lang = $("#lang");

      if (dataUser.role) {
        $role.val(dataUser.role).select2("val", dataUser.role);
      }

      $("#messages-container").html("");

      $(".ayuda-context").popover();

      $lang.val(dataUser.lang).select2("val", dataUser.lang);

      $("#form-accounts-users-detail")
        .bootstrapValidator({
          onSuccess: function (e) {
            self.save();
          },
          onError: function (e) {
            var alert = new AlertView({
              el: "#messages-container",
              type: "danger",
              msg: "ACCOUNTS.USERS.MSG_VALIDATION_ERR",
            });
            alert.render();
            scrollTop();
          },
          fields: {
            email: {
              validators: {
                callback: {
                  field: "email",
                  message: $.i18n.translate("ACCOUNTS.USERS.LBL_ERROR_403"),
                  callback: function (value, validator, $field) {
                    value = $field.val();
                    if (!value) {
                      return false;
                    }
                    if (self.me.isSuperAdmim()) return true;
                    if (self.model.isNew()) return true;
                    return value == dataUser.email;
                  },
                },
              },
            },
            password: {
              validators: {
                callback: {
                  callback: function (value, validator, $field) {
                    value = $field.val();

                    if (!value) {
                      return true;
                    }
                    return PasswordValidatorHelper.passwordValidator(value);
                  },
                },
                identical: {
                  field: "repeat-password",
                  message: $.i18n.translate(
                    "FORM.VALIDATION.TXT_PASSWORD_IDENTICAL"
                  ),
                },
              },
            },
            "repeat-password": {
              validators: {
                callback: {
                  message: $.i18n.translate(
                    "FORM.VALIDATION.TXT_MANDATORY_FIELD"
                  ),
                  callback: function (value, validator, $field) {
                    if (!self.model.isNew()) return true;
                    return !!value;
                  },
                },
                identical: {
                  field: "password",
                  message: $.i18n.translate(
                    "FORM.VALIDATION.TXT_PASSWORD_IDENTICAL"
                  ),
                },
              },
            },
          },
        })
        .on("error.field.bv", function (e, data) {
          var that = $(e.target);
        });
    },

    serialize: function () {
      return {
        user: this.model,
        myself: this.myself,
        group: this.group,
      };
    },
    save: function () {
      var self = this;
      var oldRole = this.model.get("role");
      var form = $("#form-accounts-users-detail");
      var data = {};
      if (!this.model.isNew()) {
        data.id = this.model.get("id");
      }
      form.serializeArray().map(function (item) {
        data[item.name] = item.value;
      });
      if (!self.myself) {
        _.each(this.model.get("services"), function (service) {
          _.each(service.companies, function (company) {
            var id = service.id + "-" + company.id;
            if (self.myself) {
              company.active = company.activeServiceCompany;
            } else {
              company.active = data[id] === "on";
            }
            if (data[id]) {
              delete data[id];
            }
          });
        });
      } else {
        this.model.clear();
      }

      this.model.set(data);
      scrollTop();
      this.model.save(null, {
        success: function () {
          self.alertView = new AlertView({
            type: "success",
            msg: "ACCOUNTS.USERS.MSG_OK",
          });
          self.sendEventOnboardValidation(oldRole);
          new MDSidebarJS({
            model: self.me,
            el: "#md__sidebar__wrapper",
          }).loadServices();
        },
        error: function (model, response) {
          console.log(response);
        },
      });
    },

    getListLoginHistoryModel: function (user_id) {
      this.listLoginHistoryModel = new ListLoginHistoryModel();
      this.listLoginHistoryModel.set({ id: user_id });
      this.listLoginHistoryModel.fetch();
    },

    renderModalLoginHistory: function (event) {
      event.preventDefault();
      this.getListLoginHistoryModel(this.model.get("id"));
      $("#renderModalLoginHistory").html("");
      this.listenTo(
        this.listLoginHistoryModel,
        "reset sync request error",
        function () {
          var modalview = new ModalLoginHistoryView({
            listLoginHistoryModel: this.listLoginHistoryModel,
          });
          $("#renderModalLoginHistory").html(modalview.render().el);
          $("#modalLoginHistory").modal("show");
          $(".ayuda-context-login-history").popover();
        }
      );
    },
    sendEventOnboardValidation: function (oldRole) {
      if (this.myself) return;
      if (!this.me.isSuperAdmim()) return;
      if (this.model.get("role") !== CommonHelper.ROL_ADM_MDIRECTOR) return;
      if (oldRole !== CommonHelper.ROL_ADM_MDIRECTOR_NEWFREE) return;
      this.pushTag();
    },

    defaultDataPushTag: function () {
      return {
        event: "eecomm.validation",
        ecommerce: {
          navigation: {
            userData: {
              currentLang: "",
              createdAt: "",
              gruid: "",
              id: "",
              validatedAt: "",
            },
            activeProducts: [
              {
                name: "MD Free 5K Emails",
              },
            ],
          },
        },
      };
    },

    pushTag: function () {
      var self = this;
      this.sha256(this.group.get("id"), function (digest) {
        var data = self.defaultDataPushTag();
        data.ecommerce.navigation.userData.currentLang = self.model.get("lang");
        data.ecommerce.navigation.userData.createdAt =
          self.group.get("createdAt");
        data.ecommerce.navigation.userData.gruid = digest;
        data.ecommerce.navigation.userData.id = self.group.get("id");
        data.ecommerce.navigation.userData.validatedAt =
          new Date().toLocaleString();
        console.log("pushTag", data);
        $.tagManager("push", data);
      });
    },
  });

  module.exports = View;
});

